import React from "react"
import PropTypes from "prop-types"
import { useTheme, GridItem as CHGridItem } from "@chakra-ui/react"

import { forwardRef } from "../../Hooks"

export const GridItem = forwardRef(({ variant, children, ...props }, ref) => {
  const theme = useTheme()
  const {
    customComponents: { gridItem },
  } = theme
  const { colSpan } = gridItem

  return (
    <CHGridItem ref={ref} colSpan={colSpan[variant]} {...props}>
      {children}
    </CHGridItem>
  )
})

GridItem.propTypes = {
  variant: PropTypes.oneOf([
    "4-6-2",
    "4-6-4-3",
    "4-6-4",
    "4-3-4-3",
    "4-6-5",
    "4-6",
    "4-6-7",
    "4-6-8",
    "4-6-9",
    "4-6-10",
  ]),
}
